import type { GameLevel } from '../../types/game';

// Solution: Black = 2, 5, 10 | Sheriff = 8 | Red = 1, 3, 4, 6, 7, 9
//
// Deduction path:
// 1. Hint 3 (sheriff is real) + sheriff checks → seats 2 and 10 are black
// 2. Hint 1 (3 blacks voted same target day 1) → day 1: seats 2,5,10 all voted for seat 8 → blacks = 2,5,10
// 3. Hint 2 (seats 1,4,7,9 are red) + night kills red → eliminates remaining ambiguity
// 4. Seat 8 = sheriff (only claimant, confirmed real by hint 3)

export const LEVEL_001: GameLevel = {
  id: 'level-001',
  title: 'Первое дело',
  difficulty: 'beginner',
  brief: `Детектив, перед вами протокол первой партии.

Той ночью мафия устранила Игрока 3. На первом заседании стол единогласно проголосовал за удаление Игрока 5.

Второй ночью был убит Игрок 6. На втором заседании вскрылся Шериф — но к тому моменту мафия уже контролировала голосование. Игрок 2 был выгнан.

Ваша задача: определить роли всех десяти участников. Помните: у этой головоломки есть единственное верное решение.`,

  nights: [
    { night: 1, killedPlayer: 3 },
    { night: 2, killedPlayer: 6 },
  ],

  days: [
    {
      day: 1,
      votes: [
        { voter: 1, target: 5 },
        { voter: 2, target: 8 },
        { voter: 4, target: 5 },
        { voter: 5, target: 8 },
        { voter: 6, target: 5 },
        { voter: 7, target: 5 },
        { voter: 8, target: 2 },
        { voter: 9, target: 5 },
        { voter: 10, target: 8 },
      ],
      evictedPlayer: 5,
    },
    {
      day: 2,
      votes: [
        { voter: 1, target: 2 },
        { voter: 2, target: 8 },
        { voter: 4, target: 2 },
        { voter: 7, target: 2 },
        { voter: 8, target: 10 },
        { voter: 9, target: 2 },
        { voter: 10, target: 8 },
      ],
      evictedPlayer: 2,
    },
  ],

  sheriffClaims: [
    {
      claimant: 8,
      day: 2,
      checks: [
        { night: 1, checkedPlayer: 2, result: 'black' },
        { night: 2, checkedPlayer: 10, result: 'black' },
      ],
    },
  ],

  hints: [
    {
      id: 'h1',
      type: 'behavior',
      text: 'В первый день трое чёрных голосовали согласованно — все трое против одного и того же красного игрока.',
    },
    {
      id: 'h2',
      type: 'arithmetic',
      text: 'Среди игроков 1, 4, 7 и 9 нет ни одного чёрного.',
    },
    {
      id: 'h3',
      type: 'sheriff',
      text: 'Единственный вскрывшийся — настоящий Шериф. Его проверки верны.',
    },
  ],

  solution: {
    1: 'red',
    2: 'black',
    3: 'red',
    4: 'red',
    5: 'black',
    6: 'red',
    7: 'red',
    8: 'sheriff',
    9: 'red',
    10: 'black',
  },
};
